import { useContext } from 'react';

import { UITextContext } from './UITextContext';
import type { UITranslations } from './types';

/**
 * Resolution order: explicit per-component string props (handled by the
 * caller before falling back to this) → app-provided `UIProvider` locale →
 * shipped English default (this context's initial value).
 */
export function useUIText(): UITranslations {
    return useContext(UITextContext);
}
